// extracted by mini-css-extract-plugin
export default {"CloseIcon":"index__CloseIcon__Sxf2t","TitleBlock":"index__TitleBlock__v7mZt","TitleIcon":"index__TitleIcon__CNAdv"};